import { memo as Memo } from 'react';

//* Components
import Video from '../Video';
import Image from '@components/global/Image';

//* Styles
import DoubleImageStyle from './style';

const DoubleImage = Memo(({ data }) => {
	return (
		<DoubleImageStyle className={`${data.imageMode === 'landscape' ? 'landscape' : 'portrait'} ${data.smallImagePosition === 'right' ? 'right' : ''}`}>
			<div className={'first_img'}>
				{data.firstImage.fields.file.contentType !== 'video/mp4' ? (
					<Image
						src={data.firstImage.fields.file.url}
						alt={data.firstImage.fields.title}
					/>
				) : (
					<Video data={data.firstImage.fields.file.url} />
				)}
			</div>

			<div className={'second_img'}>
				{data.firstImage.fields.file.contentType !== 'video/mp4' ? (
					<Image
						src={data.secondImage.fields.file.url}
						alt={data.secondImage.fields.title}
					/>
				) : (
					<Video data={data.secondImage.fields.file.url} />
				)}
			</div>
		</DoubleImageStyle>
	);
});

export default DoubleImage;
